import { getAppointmentStatusValues } from "./appointment.ts";

export enum HistoryActionType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  UPDATE_ORDERED_BY = "UPDATE_ORDERED_BY",
  UPDATE_STATUS = "UPDATE_STATUS",
  UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT",
  UPDATE_OPERATOR = "UPDATE_OPERATOR",
  ADD_FILE = "ADD_FILE",
  SMS_SEND = "SMS_SEND",
  EMAIL_SEND = "EMAIL_SEND",
  EMAIL_SEND_COMMENT = "EMAIL_SEND_COMMENT",
  PLANNING = "PLANNING",
  WAITING_TENANT = "WAITING_TENANT",
  FIRST_REMINDER = "FIRST_REMINDER",
  SECOND_REMINDER = "SECOND_REMINDER",
  PLANNED = "PLANNED",
  CONFIRMED = "CONFIRMED",
  DONE = "DONE",
  CANCEL = "CANCEL",
  TO_PROCESS = "TO_PROCESS",
  FINALIZED = "FINALIZED",
}

export const historyActionValues = [
  {
    type: HistoryActionType.CREATE,
    color: "#666",
    status: "Commande créée",
    icon: "pi-plus",
  },
  {
    type: HistoryActionType.UPDATE,
    color: "#666",
    status: "Commande mise à jour",
    icon: "pi-pencil",
  },
  {
    type: HistoryActionType.UPDATE_ORDERED_BY,
    color: "#344ceb",
    status: "Commanditaire mis à jour",
    icon: "pi-pencil",
  },
  {
    type: HistoryActionType.UPDATE_STATUS,
    color: "#666",
    status: "Statut mis à jour manuellement",
    icon: "pi-pencil",
  },
  {
    type: HistoryActionType.UPDATE_APPOINTMENT,
    color: "#666",
    status: "Date du RDV mise à jour",
    icon: "pi-pencil",
  },
  {
    type: HistoryActionType.UPDATE_OPERATOR,
    color: "#666",
    status: "Opérateur mis à jour",
    icon: "pi-pencil",
  },
  {
    type: HistoryActionType.ADD_FILE,
    color: "#f7b924",
    status: "Fichier ajouté",
    icon: "pi-file",
  },
  {
    type: HistoryActionType.SMS_SEND,
    color: "#ffb822",
    status: "SMS envoyé",
    icon: "pi-send",
  },
  {
    type: HistoryActionType.EMAIL_SEND,
    color: "#e34b4a",
    status: "Email envoyé",
    icon: "pi-envelope",
  },
  {
    type: HistoryActionType.EMAIL_SEND_COMMENT,
    color: "#e34b4a",
    status: "Email envoyé",
    icon: "pi-envelope",
  },
  {
    type: HistoryActionType.PLANNING,
    color: getAppointmentStatusValues(HistoryActionType.PLANNING).color,
    status: getAppointmentStatusValues(HistoryActionType.PLANNING).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.WAITING_TENANT,
    color: getAppointmentStatusValues(HistoryActionType.WAITING_TENANT).color,
    status: getAppointmentStatusValues(HistoryActionType.WAITING_TENANT).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.FIRST_REMINDER,
    color: getAppointmentStatusValues(HistoryActionType.FIRST_REMINDER).color,
    status: getAppointmentStatusValues(HistoryActionType.FIRST_REMINDER).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.SECOND_REMINDER,
    color: getAppointmentStatusValues(HistoryActionType.SECOND_REMINDER).color,
    status: getAppointmentStatusValues(HistoryActionType.SECOND_REMINDER).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.PLANNED,
    color: getAppointmentStatusValues(HistoryActionType.PLANNED).color,
    status: getAppointmentStatusValues(HistoryActionType.PLANNED).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.CONFIRMED,
    color: getAppointmentStatusValues(HistoryActionType.CONFIRMED).color,
    status: getAppointmentStatusValues(HistoryActionType.CONFIRMED).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.DONE,
    color: getAppointmentStatusValues(HistoryActionType.DONE).color,
    status: getAppointmentStatusValues(HistoryActionType.DONE).name,
    icon: "pi-check",
  },
  {
    type: HistoryActionType.CANCEL,
    color: getAppointmentStatusValues(HistoryActionType.CANCEL).color,
    status: getAppointmentStatusValues(HistoryActionType.CANCEL).name,
    icon: "pi-ban",
  },
  {
    type: HistoryActionType.TO_PROCESS,
    color: getAppointmentStatusValues(HistoryActionType.TO_PROCESS).color,
    status: getAppointmentStatusValues(HistoryActionType.TO_PROCESS).name,
    icon: "pi-hourglass",
  },
  {
    type: HistoryActionType.FINALIZED,
    color: getAppointmentStatusValues(HistoryActionType.FINALIZED).color,
    status: getAppointmentStatusValues(HistoryActionType.FINALIZED).name,
    icon: "pi-check",
  },
];

export const getHistoryStatusValuesByType = (
  type: HistoryActionType | string
) => {
  return historyActionValues.filter(
    (entry: { type: string }) => entry.type === type
  )[0];
};
